import * as React from "react";
import * as ReactDOM from "react-dom";
import Ajax from "../Ajax";

interface IFormProps {
  token: string
}
interface MyStates {
  payment: object
  ajaxLoaded: number
}
export default class OrderCheck extends React.Component<IFormProps, MyStates>{

  constructor(props:IFormProps) {
    super(props);

    this.state = {
      payment: {},
      ajaxLoaded: 0,
    }

    this.getPayment()
  }
  private getPayment(){
    var ajax = new Ajax(window.location.origin+ '/api/simplepay/payment');
    ajax.doPost({ref: this.props.token}).then((response) => {
      if( this.state.payment?.['ipn_status'] == null ||  this.state.payment?.['ipn_status'] == undefined || this.state.payment?.['ipn_status'] == '' ) {
        setTimeout(() => { this.getPayment() }, 5000)
      }
      this.setState({
        payment: response.payment,
        ajaxLoaded: Math.random(),
      })
    })
  }

  private paymentStatus(){
    let text = '-'
    if(this.state.payment?.['api_event_status'] == 'SUCCESS'){
      text = 'Sikeres!'
    } else if(this.state.payment?.['api_event_status'] == 'FAIL'){
      text = 'Sikertelen!'
    } else if(this.state.payment?.['api_event_status'] == 'TIMEOUT'){
      text = 'Hiba: fizetés megszakítva!'
    } else if(this.state.payment?.['api_event_status'] == 'CANCEL'){
      text = 'Hiba: időtúllépés!'
    } 

    return (<>{ text }</>)
  }

  private paymentIpn(){
    let text = '-'
    if(this.state.payment?.['ipn_status'] == null){
      text = 'Lekérés folyamatban'
    } else if(this.state.payment?.['ipn_status'] == 'FINISHED'){
      text = 'Sikeres!'
    } else  if(this.state.payment?.['ipn_status'] == 'CANCELLED'){
      text = 'Hiba: fizetés megszakítva!'
    } else  if(this.state.payment?.['ipn_status'] == 'TIMEOUT '){
      text = 'Hiba: időtúllépés!'
    } else {
      text = 'Hiba történt!'
    }
    return (<>{ text }</>)
  }

  private paymentTransactionID(){
    return (<>{ this.state.payment?.['api_transaction_id'] ?? '-' }</>)
  }

  private paymentText(){
    let text = '-'
    if(this.state.payment?.['ipn_status'] == null){
      text = ''
    } else if(this.state.payment?.['ipn_status'] == 'FINISHED'){
      text = 'Fizetése sikeresen megérkezett, a részleteket rendszerünk a megadott e-mail címre kiküldte, kérjük ott tájékozódjon!'
    } else if( this.state.payment?.['ipn_status'] == 'FAIL' || this.state.payment?.['ipn_status'] == 'TIMEOUT' || this.state.payment?.['ipn_status'] == 'CANCEL' || this.state.payment?.['ipn_status'] == 'NOTAUTHORIZED' ) {
      text = 'Kérjük, ellenőrizze a tranzakció során megadott adatok helyességét. Amennyiben minden adatot helyesen adott meg, a visszautasítás okának kivizsgálása kapcsán kérjük, szíveskedjen kapcsolatba lépni kártyakibocsátó bankjával.'
    }
    return (<>{ text }</>)
  }

  

  public render() {
      return (
      <>
        <div className="row">
          <div className="col-md-12" key={'payment_'+this.state.ajaxLoaded}>
            <p>{ this.paymentText() }</p>
            <table>
              <tbody>
                {this.state.payment?.['api_event_status'] != 'TIMEOUT'?
                <tr>
                  <td style={{width: '250px'}}><b>Fizetési státusz:</b></td>
                  <td>{ this.paymentStatus() }</td>
                </tr>
                :<></>}
                <tr>
                  <td><b>Visszaigazolás:</b></td>
                  <td>{ this.paymentIpn() }</td>
                </tr>
                <tr>
                  <td><b>SimplePay tranzakció azonosító:</b></td>
                  <td>{ this.paymentTransactionID() }</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </>
      );
  }
}

export class InitOrderCheck {
  constructor() {
      var div: HTMLDivElement = document.getElementById('payment_datas') as HTMLDivElement;
      if (div !== null) {
          var data:any = div.dataset;
          ReactDOM.render(<OrderCheck token={data.ref}/>, div);
      }
  }
}